<script lang="ts">
  import X from '@lucide/svelte/icons/x';

  import { strings } from '../strings';
  import IconButton from './IconButton.svelte';
  import type { Toasts } from './toasts.svelte';

  let { toasts }: { toasts: Toasts } = $props();
</script>

<section
  aria-label={strings.notifications}
  class="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex flex-col items-center gap-2 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] print:hidden"
>
  <div aria-live="polite" aria-atomic="false" class="flex w-full flex-col items-center gap-2">
    {#each toasts.items as toast (toast.id)}
      <div
        class="pointer-events-auto flex w-full max-w-md items-center gap-3 rounded-xl bg-ink py-2 pr-2 pl-4 text-sm text-canvas shadow-lg"
      >
        <p class="flex-1">{toast.message}</p>
        {#if toast.action}
          <button
            type="button"
            class="rounded-lg px-3 py-1.5 font-semibold text-canvas underline-offset-2 hover:underline pointer-coarse:min-h-11"
            onclick={() => {
              toasts.act(toast.id);
            }}
          >
            {toast.action.label}
          </button>
        {/if}
        <IconButton
          label={strings.dismiss}
          icon={X}
          size="sm"
          tooltip="none"
          class="text-canvas/80 hover:bg-transparent hover:text-canvas"
          onclick={() => {
            toasts.dismiss(toast.id);
          }}
        />
      </div>
    {/each}
  </div>
</section>
